import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/native-apps/")({
  staticData: {
    title: "nativeApps.title",
  },
});
